import * as React from 'react';
import { Image, Text, View, StyleSheet } from 'react-native';
import * as AppUtilities from "../context/AppUtilities";
import * as AppConstants from "../context/AppConstants";
import * as AppState from "../context/AppState";
import { CustomScrollView } from '../components/CustomScrollView';
import { FilterSlider } from '../components/FilterSlider';

export function Test({ navigation }) {
  return (
    <CustomScrollView>
      <Text>Hello World</Text>
      <FilterSlider vertical={true} />
    </CustomScrollView>
  );
}
